import { Component } from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { FormGroup, FormLabel } from 'react-bootstrap';
import { actions, Errors } from 'forms/rrf';
import _ from 'lodash';

import './searchable-select.css';

class SearchableSelect extends Component {
  state = { value: '', options: [] }

  componentDidMount() {
    const {
      model,
      required,
      value,
      options,
      dispatch
    } = this.props;

    if (model && required && !value) {
      dispatch(actions.setValidity(model, false));
    }
    if (options && value !== undefined) {
      this.setState({
        options,
        value
      });
    }
  }

  componentDidUpdate(prevProps) {
    const {
      options,
      value,
      model,
      dispatch
    } = this.props;

    if (prevProps.value !== value || !_.isEqual(prevProps.options, options)) {
      this.setState({
        options,
        value
      });

      if (model) {
        dispatch(actions.change(model, value));
      }
    }
  }

  handleChange(option) {
    const { model, onChange, dispatch } = this.props;
    const value = option ? option.value : '';

    dispatch(actions.change(model, value));

    if (onChange && onChange !== undefined) {
      onChange(value);
    }

    this.handleError(value);
  }

  handleError = (val) => {
    const { model, dispatch, required } = this.props;
    const value = val || this.state.value;

    if (value === '' && required) {
      dispatch(actions.setValidity(model, false));
      dispatch(actions.setErrors(model, { required: true }));
    } else {
      dispatch(actions.setValidity(model, true));
      dispatch(actions.setErrors(model, { required: false }));
    }
  }

  render() {
    const {
      controlId,
      label,
      required,
      disabled,
      placeholder,
      model,
      messages
    } = this.props;
    const { value, options } = this.state;

    const selectedOption = options ? options.find(o => o.value === value) || null : null;

    return (
      <FormGroup
        className="form-group select-formgroup"
        controlId={controlId}
      >
        {label && (
          <FormLabel>
            {label}
            {required && '*'}
          </FormLabel>
        )}
        <Select
          className="form-control"
          classNamePrefix="rs"
          isSearchable
          closeMenuOnSelect
          isDisabled={disabled}
          onChange={option => this.handleChange(option)}
          options={options}
          placeholder={placeholder || 'Select one...'}
          value={selectedOption}
          onBlur={() => this.handleError(value)}
        />

        <Errors
          className="errors"
          messages={messages || { required: 'This field is required' }}
          model={model}
          show
        />
      </FormGroup>
    );
  }
}

export default connect(null)(SearchableSelect);
